<div class="p-grid p-formgrid p-fluid">
  <div class="p-field p-col-12">
    <span class="p-float-label">
      <input type="text" pInputText id="userInput" [ngModelOptions]="{standalone: true}" [(ngModel)]="userInput" (ngModelChange)="validate()" class="p-inputtext-lg" [class.ng-invalid]="!valid" />
      <label for="userInput">{{ inputLabel }}</label>
    </span>
  </div>
</div>
